import React, { Component } from 'react';

class index extends Component {

  state = {
  }

  componentDidMount = () => {
    
  }

  render() {
    return (
      <div className="notfound-container">
        <h1>404</h1>
        <p>Sorry, the page you have requested does not exist.<br />Please check you have entered the correct URL.</p>
        <a href="/">BACK TO HOMEPAGE</a>
      </div>
    );
  }
}

export default index;


// WEBPACK FOOTER //
// ./src/pages/NotFound/index.js